import { Box, Flex, Icon, Text, Tooltip } from '@chakra-ui/react';
import { InputField } from './InputField';
import { useField } from 'formik';
import { useRef, useState } from 'react';
import { Edit03 } from '@kula-ai/icons/outline/Edit03';
import { XClose } from '@kula-ai/icons/outline/XClose';
import { Check } from '@kula-ai/icons/outline/Check';

interface InputInlineEditProps {
  item?: Record<string, unknown>;
  field: any;
  formik?: any;
}

export const InputInlineEdit = ({
  item = {},
  field,
  formik,
}: InputInlineEditProps) => {
  const {
    name,
    textProps = {},
    inlineMode = 'notSwap', //swap
    additionalText,
    toolTipText,
    disabled,
  } = item as any;

  const [isEditing, setEditing] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [_field, meta, helpers] = useField(name);
  const { setValue } = helpers;
  const hasInputValue = Boolean(meta?.value);

  const handleSave = () => {
    const val = inputRef?.current?.value;
    if (val) {
      setValue(val);
      setEditing(false);
    }
  };

  return (
    <Flex alignItems="center" gap="15px">
      <Flex alignItems="center" gap="1em" w="100%">
        <InputField
          item={{ ...item, isEditable: isEditing, inputRef }}
          field={field}
          formik={formik}
        />
        {inlineMode === 'swap' && (
          <Flex gap=".5em" mr="15em">
            <Icon
              as={Check}
              color="ats-primary"
              opacity={hasInputValue ? 1 : 0.5}
              cursor={hasInputValue ? 'pointer' : 'not-allowed'}
              onClick={handleSave}
              w="1.5em"
              h="1.5em"
            />
            <Icon
              as={XClose}
              color="ats-negative"
              cursor="pointer"
              onClick={() => setEditing(false)}
              w="1.5em"
              h="1.5em"
            />
          </Flex>
        )}
      </Flex>
      {!isEditing && !disabled && (
        <Tooltip variant="default" label={toolTipText}>
          <Box mt="10px">
            <Icon
              as={Edit03}
              cursor="pointer"
              _hover={{
                color: 'ats-primary',
              }}
              onClick={() => setEditing(true)}
            />
          </Box>
        </Tooltip>
      )}
      {additionalText && (
        <Text fontSize="sm" color="ats-text-secondary" {...textProps}>
          {additionalText}
        </Text>
      )}
    </Flex>
  );
};
